module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.crumbs && _vm.crumbs.length) ? _c('ul', {
    class: _vm.crumbClass
  }, _vm._l((_vm.crumbs), function(crumb, i) {
    return _c('li', [_c('router-link', {
      staticClass: "white hover-red b pointer",
      attrs: {
        "to": {
          path: crumb.url
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-chevron-left fa-2x white"
    })])], 1)
  })) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e1379d1","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/layout/Breadcrumb.vue
// module id = 1281
// module chunks = 1